import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  FulfillNeedDialog,
  FulfillNeedDialogCallbackInput,
  FulfillNeedDialogUniqueProps,
} from '../FulfillNeedDialog';

const { useDialogForContext, useDialog: useFulfillNeedDialog } = getDialogHooks<
  FulfillNeedDialogUniqueProps,
  FulfillNeedDialogCallbackInput
>(FulfillNeedDialog);

export const useFulfillNeedDialogForContext = useDialogForContext;
export default useFulfillNeedDialog;
